// extracted by mini-css-extract-plugin
export var legendIndicator = "_ft-1";
export var legendRight = "_ft-0";